import React from 'react'
import { Result } from 'antd'
import { addOwlError } from '@bike/fe-owl'

interface Props {
  children?: any
}

interface State {
  hasError: boolean
  error?: any
  errorInfo?: any
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({ error, errorInfo })
    addOwlError({
      name: `[global] ${error.message}`,
      msg: {
        info: errorInfo,
        stack: error.stack,
      },
    })
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state
      return process.env.NODE_ENV === 'development' ? (
        <div>
          <h1>Something went wrong.</h1>
          <p>{error && error.message}</p>
          <pre>{error && error.stack}</pre>
        </div>
      ) : (
        <Result title={<h4>页面开了小差，请稍后再试。</h4>} />
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
